import { render, staticRenderFns } from "./resultQuery.vue?vue&type=template&id=e973b37a&scoped=true&"
import script from "./resultQuery.vue?vue&type=script&lang=js&"
export * from "./resultQuery.vue?vue&type=script&lang=js&"
import style0 from "./resultQuery.vue?vue&type=style&index=0&id=e973b37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e973b37a",
  null
  
)

export default component.exports